import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { Breadcrumbs } from "@/components/navigation/Breadcrumbs";
import { QuickCreateMenu } from "@/components/navigation/QuickCreateMenu";
import { NotificationMenu } from "@/components/navigation/NotificationMenu";
import { ProfileMenu } from "@/components/navigation/ProfileMenu";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { CommandPaletteTrigger } from "@/components/layout/CommandPalette";

export function Topbar({ collapsed, onOpenMobile }) {
  return (
    <header
      data-testid="topbar"
      className={cn(
        "fixed right-0 top-0 z-30 flex h-16 items-center gap-3 border-b border-border/60 px-4 backdrop-blur-xl transition-[left] duration-200 sm:px-6",
        "bg-background/70 dark:bg-background/60",
        "left-0",
        collapsed ? "lg:left-[76px]" : "lg:left-64"
      )}
    >
      <button
        type="button"
        onClick={onOpenMobile}
        data-testid="mobile-menu-trigger"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-ring lg:hidden"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      <Breadcrumbs />

      <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
        <CommandPaletteTrigger />
        <QuickCreateMenu />
        <ThemeToggle />
        <NotificationMenu />
        <div className="mx-1 hidden h-6 w-px bg-border/60 sm:block" />
        <ProfileMenu />
      </div>
    </header>
  );
}
